import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify, {
  theme: {
    primary: '#c92027',
    secondary: '#424242',
    accent: '#207cc9',
    error: '#E03318',
    info: '#0E547C',
    success: '#20c96e',
    warning: '#D2CF36',
    negative: '#fd706c',
    positive: '#8bd7b0',
    neutral: '#fdcb64',
    danger: '#FE9E58'
  }
})
